'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	FORM: {
		name: 'Username',
		minecraftName: 'Minecraft Java Name',
		minecraftPeName: 'Minecraft PE Name',
		email: 'Email Address',
		paymentEmail: 'Cardholder Email',
		password: 'Password',
		gender: 'Gender',
		dateOfBirth: 'Date of Birth',
		button: 'Save'
	}
});
